import { Component, HostListener, OnInit, signal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './navbar.component.html',
})
export class NavbarComponent implements OnInit {
  private dropdownOpen = signal(false);
  private mobileMenuOpen = signal(false);
  private scrollY = signal(0);

  ngOnInit() {
    // Set initial scroll position
    this.scrollY.set(window.scrollY);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrollY.set(window.scrollY);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    // Close dropdown when clicking outside
    const target = event.target as HTMLElement;
    if (!target.closest('.relative')) {
      this.dropdownOpen.set(false);
    }
  }

  isDropdownOpen() {
    return this.dropdownOpen();
  }

  isMobileMenuOpen() {
    return this.mobileMenuOpen();
  }

  showDropdown() {
    this.dropdownOpen.set(true);
  }

  hideDropdown() {
    setTimeout(() => {
      this.dropdownOpen.set(false);
    }, 150);
  }

  toggleDropdown() {
    this.dropdownOpen.set(!this.dropdownOpen());
  }

  closeDropdown() {
    this.dropdownOpen.set(false);
  }

  toggleMobileMenu() {
    this.mobileMenuOpen.set(!this.mobileMenuOpen());
  }

  closeMobileMenu() {
    this.mobileMenuOpen.set(false);
  }

  openContactModal() {
    // TODO: Implement contact modal or redirect to contact page
    console.log('Opening contact modal...');
  }

  scrollToSection(sectionId: string, event: Event) {
    event.preventDefault();
    
    const element = document.getElementById(sectionId);
    if (element) {
      const navHeight = 118; // Navbar height
      const elementPosition = element.offsetTop - navHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  }
}
